import ApplicationController from "./application_controller";

export default class AlertController extends ApplicationController {
  static targets = ["container", "content"];
  static values = { content: String };

  declare readonly containerTarget: HTMLElement;
  declare readonly contentTarget: HTMLElement;
  declare contentValue: string;

  connect() {
    if (this.contentValue) {
      this.displayContent(this.contentValue);
    }
  }

  show(event: StimulusEvent) {
    this.displayContent(event.detail.html);
  }

  hide() {
    this.containerTarget.toggleAttribute("hidden", true);
  }

  displayContent(content: string) {
    this.contentTarget.innerHTML = content;
    this.containerTarget.removeAttribute("hidden");
  }
}
